import Button from '@components/Button/Button'
import { useUserData } from '@contexts/UserDataContext'
import axios from 'axios'
import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'

const Notifications = () => {
  const [isNotificationEnabled, setIsNotificationEnabled] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { userData } = useUserData()
  const [selectedHour, setSelectedHour] = useState(21)
  const [showUpdateHour, setShowUpdateHour] = useState(false)

  const subscribeForNotifications = async () => {
    if ('Notification' in window) {
      setIsLoading(true)
      // ask for permission and check if permission is granted by user
      const permission = await Notification.requestPermission()
      if (permission !== 'granted') {
        toast.error('Bildirim izni verilmedi.')
        setIsLoading(false)
        return
      }
      // check if service worker is supported
      if (!('serviceWorker' in navigator)) {
        toast.error('Tarayıcınız bildirimleri desteklemiyor.')
        setIsLoading(false)
        return
      }
      const id = localStorage.getItem('notificationId')

      // wait for service worker to be ready
      const registration = await navigator.serviceWorker.ready
      // get push subscription
      const subscription = await registration.pushManager.getSubscription()

      // if there is no subscription that means
      // the user has not subscribed before
      // so we subscribe them
      if (!subscription) {
        const newSubscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey:
            'BGEa8b3k3muO7NU6dsHY0BEHgQJPHuHolwgUaERCH64zIbtM4AoD8sGqcPPFjztjOQxjjj2g7cYG_NwJl2UL_qE',
        })
        // send new subscription to server
        const response = await axios.post('/api/notifications', {
          id,
          subscription: newSubscription,
          hour: Number(selectedHour),
          email: userData?.email,
          createdAt: new Date().toISOString(),
          deviceType: navigator?.userAgent,
        })
        const { id: idFromResponse } = response.data
        localStorage.setItem('notificationId', idFromResponse)
        localStorage.setItem('notificationHour', selectedHour.toString())
        // save subscription to local storage
        setIsNotificationEnabled(true)
        setIsLoading(false)
        setShowUpdateHour(false)
        toast.success('Bildirimler başarıyla açıldı.')
      } else {
        // if there is a subscription
        // we update the subscription
        const { data } = await axios.post('/api/notifications', {
          id,
          subscription,
          hour: Number(selectedHour),
          email: userData?.email,
        })
        if (showUpdateHour) {
          toast.success('Bildirim saati başarıyla güncellendi.')
        } else {
          toast.success('Bildirimler başarıyla açıldı.')
        }
        localStorage.setItem('notificationId', data.id)
        localStorage.setItem('notificationHour', selectedHour.toString())
        setIsNotificationEnabled(true)
        setIsLoading(false)
        setShowUpdateHour(false)
      }
    } else {
      toast.error('Tarayıcınız bildirimleri desteklemiyor.')
    }
  }

  const unSubscribeForNotifications = async () => {
    const id = localStorage.getItem('notificationId')
    setIsLoading(true)
    await axios.put(`/api/notifications/`, { id })
    localStorage.removeItem('notificationId')
    setIsNotificationEnabled(false)
    setIsLoading(false)
    toast.success('Bildirimler başarıyla kapatıldı.')
  }

  useEffect(() => {
    const id = localStorage.getItem('notificationId')
    const hour = localStorage.getItem('notificationHour')
    if (id) {
      setIsNotificationEnabled(true)
      setSelectedHour(Number(hour))
    }
  }, [])

  useEffect(() => {
    if (
      isNotificationEnabled &&
      selectedHour !== Number(localStorage.getItem('notificationHour'))
    ) {
      setShowUpdateHour(true)
    } else {
      setShowUpdateHour(false)
    }
  }, [selectedHour, isNotificationEnabled])

  return (
    <div>
      <h2 className="mb-2 text-lg font-bold">Bildirim Ayarları</h2>
      <small className="font-thin">
        Dilerseniz her gün sizin seçtiğiniz bir saatte size bir hatırlatıcı bildirim
        gönderebiliriz. Bunun için tarayıcınızın bildirimlerine izin vermeniz
        gerekmektedir. <br />
        Bildirimleri dilediğiniz zaman kapatabilirsiniz.
      </small>
      <div className="mt-4 flex items-center">
        <label className="mr-2">Bildirim Saati:</label>
        <select
          className="h-8 w-20 rounded-md border border-gray-300 px-2 py-1"
          value={selectedHour}
          onChange={(e) => setSelectedHour(parseInt(e.target.value))}
        >
          {Array.from(Array(24).keys()).map((hour) => (
            <option key={hour} value={hour}>
              {hour}:00
            </option>
          ))}
        </select>
      </div>

      {isNotificationEnabled && showUpdateHour && (
        <div className="py-4">
          <Button
            onClick={subscribeForNotifications}
            disabled={isLoading}
            className="py-1"
            color="blue"
          >
            Saati Güncelle
          </Button>
        </div>
      )}

      {!showUpdateHour && (
        <div className="py-4">
          {isNotificationEnabled ? (
            <Button
              onClick={unSubscribeForNotifications}
              disabled={isLoading}
              className="py-1"
              color="red"
            >
              Bildirimleri Kapat
            </Button>
          ) : (
            <Button
              onClick={subscribeForNotifications}
              disabled={isLoading}
              className="py-1"
              color="blue"
            >
              Bildirimleri Aç
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default Notifications
